import React, {Fragment, useState} from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import { TablaPersonalizada } from 'components';
import TooltipPersonalizado from 'components/tooltip/TooltipPersonalizado';
import { functions } from 'constantes/functions';
import Base64Pdf from 'components/base64pdf';

const ListadoPersonaIndividual = ({datosGeneralesDeSolicitud}) => {
  const [responseData, setResponseData] = useState({ errorType: 'error', messageType: '', openResponse: false, })
  const[datosDelDocumentoAdjunto, setDatosDelDocumentoAdjunto] = useState({title: "", pdf: ""});
  const[mostarDocumentoAdjunto, setMostrarDocumentoAdjunto] = useState(false);
  const [header] = useState([
    { title: 'CUI del DPI', field: 'cui'},
    { title: 'Nombre de la persona', field: 'nombre'},
    { title: 'Acciones', field: 'accion', filtering: false,
    render: rowData=><div style={{minWidth: '100px'}}>
        {
            (<div>
              <TooltipPersonalizado title="Ver dpi" handleFunction={() => verDpiDePersona(rowData)} icon="visibility" fontSize={30} />
            </div>)
        }
        </div>
    },
  ]);

  const verDpiDePersona = async (elemento) => {
    if(!elemento?.docDpi) return setResponseData({ tipoDeAlerta: 'error', mensajeDeAlerta: "NO ADJUNTO DPI PARA ESTA PERSONA", mostrarRespuesta: true});

    setDatosDelDocumentoAdjunto({title: `DPI DE LA PERSONA - ${elemento?.nombre?.toUpperCase() || ""}`, pdf: elemento?.docDpi || ""})
    setMostrarDocumentoAdjunto(true)
  }

  const cerrarModalDelDocumento = () => setMostrarDocumentoAdjunto(false)

  const DescargarPDF = () => functions.descargarBase64EnPDF(datosDelDocumentoAdjunto?.pdf || "", `${datosDelDocumentoAdjunto?.title || ""}.pdf`)

  const handClose = (_, reason) => {
    if (reason === 'clickaway') {return}
    changeDataResponse('error', '', false)
  };

  const changeDataResponse = (tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta = false) => setResponseData({tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta,})

  const { errorType, messageType, openResponse} = responseData;

  return (
    <Fragment>
      <AlertaDeRespuesta type={errorType} content={messageType} open={openResponse} handClose={handClose}/>
      <Card>
          <CardContent>
            <TablaPersonalizada
                data={(datosGeneralesDeSolicitud?.solicitudPersona || []).map((p, i) => ({...p, id: p.cui || i}))}
                title={"Listado de personas"}
                header={header}
                refreshList={undefined}
                addRegister={undefined}
                pageSize={5}
            />
          </CardContent>
          {mostarDocumentoAdjunto && (
            <Base64Pdf pdf={datosDelDocumentoAdjunto?.pdf || ""} title={datosDelDocumentoAdjunto?.title || ""} open={mostarDocumentoAdjunto} handleClose={cerrarModalDelDocumento} showDownloadButton={true} src={datosDelDocumentoAdjunto?.pdf || ""} DescargarPDF={DescargarPDF} />
          )}
      </Card>
      </Fragment>
  );
}

export default ListadoPersonaIndividual;